/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import inicio from '../menu-sections/inicio'
import nosotros from '../menu-sections/nosotros'
import ayuda from '../menu-sections/ayuda'
import oferta from '../menu-sections/oferta'
import inscripciones from '../menu-sections/inscripciones'
import contacto from '../menu-sections/contacto'

// Array of sections
export default [...inicio, ...nosotros, ...oferta, ...inscripciones, ...ayuda, ...contacto]
